/** @jsx jsx */
import { Grid, IconButton, Spacer } from "@cd2/components/build/es6"
import { useFileboy } from "@cd2/fileboy-react"
import { P } from "@cd2/text/build/es6"
import { css, jsx } from "@emotion/core"
import { useState } from "react"
import { pdfjs, Document, Page } from "react-pdf"
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

import { CGButton } from "../../interfaceParts/CGButton"

export function SaaSTermsPage() {
  return (
    <div
      css={css`
        padding: 16px 16px;
        overflow: auto;
      `}
    >
      <FileboyPdfRenderer
        fileboyId="saas_term"
        name="CleverGoose SaaS terms 050122"
        includeDownload
      />
    </div>
  )
}

export function FileboyPdfRenderer({
  fileboyId,
  scale = 1,
  name,
  includeDownload,
}: {
  fileboyId: string
  scale?: number
  name?: string
  includeDownload?: boolean
}) {
  const fileboy = useFileboy()
  const [numPages, setNumPages] = useState<number | null>(null)
  const [pageNumber, setPageNumber] = useState<number>(1)

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages)
  }

  function onPageChange(dir: number) {
    if (pageNumber + dir <= 0 || pageNumber + dir > (numPages ?? 0)) {
      return
    }
    setPageNumber(pageNumber + dir)
  }

  const controls = (
    <Grid columns={["auto", "max-content", "auto"]} justifyItems="center" alignItems="center">
      <div>
        <IconButton
          onClick={() => onPageChange(-1)}
          icon="arrow-left"
          buttonStyle="text"
          disabled={pageNumber === 1}
          square
        />
      </div>
      <P align="center" blockSpacing={0}>
        Page {pageNumber} of {numPages}
      </P>
      <div>
        <IconButton
          onClick={() => onPageChange(1)}
          icon="arrow-right"
          buttonStyle="text"
          disabled={pageNumber === numPages}
          square
        />
      </div>
    </Grid>
  )

  const download = includeDownload ? (
    <div>
      <a href={fileboy.buildFileUrl(fileboyId)}>
        <CGButton leftIcon="download">Download PDF</CGButton>
      </a>
    </div>
  ) : null

  return (
    <div
      css={css`
        .react-pdf__Page__annotations {
          height: 0;
        }
        .react-pdf__Page__svg {
          min-width: 700px;
          width: 100% !important;
          height: auto !important;
          svg {
            width: 100% !important;
            height: auto !important;
          }
        }
      `}
    >
      {controls}
      <Spacer />
      <Document
        file={fileboy.buildFileUrl(fileboyId)}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={console.error}
        renderMode="svg"
        loading={
          <div
            css={css`
              height: 100px;
              display: flex;
              justify-content: center;
              align-items: center;
            `}
          >
            <P align="center">Loading {name}</P>
          </div>
        }
      >
        <Page pageNumber={pageNumber} scale={scale} />
      </Document>
      <Spacer />
      {controls}
      {download && <Spacer />}
      <div
        css={css`
          display: flex;
          justify-content: center;
        `}
      >
        {download}
      </div>
    </div>
  )
}
